import { selectItems } from "routes/schedule/lib/useSelection"
import { setRetiredSelection } from "routes/schedule/my-schedules/my-custom-schedules/retired-selection"
import { retireSchedules } from "routes/schedule/my-schedules/my-custom-schedules/controller/retire-schedules"

export function clearGlobal(ids) {
    selectItems((current) => without(current, ids))
}

export function clearRetired(ids) {
    setRetiredSelection((current) => without(current, ids))
}

export function succeeded(ids, failed) {
    const failedSet = new Set(failed)
    return ids.filter((id) => !failedSet.has(id))
}

export function retireBatch(retired) {
    return (batch) =>
        retireSchedules(retired, batch)
            .then((result) => {
                const done = new Set(result?.retired ?? [])
                return batch.filter((id) => !done.has(id))
            })
            .catch(() => batch)
}

function without(current, ids) {
    const next = { ...current }
    for (const id of ids) delete next[id]
    return next
}
